<template>
  <main>
    <v-toolbar flat color="white" class="mb-4">
      <v-toolbar-title>{{ $t("route.tags") }}</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-spacer></v-spacer>
      <v-btn @click="$refs.table_ref.toggleDialog()" color="primary">
        {{ $t("button.create") }}
      </v-btn>
    </v-toolbar>
    <wrapping-table
      @on_dialog_close="onDialogClose"
      pathName="tags"
      resName="tags"
      :headersName="headers"
      ref="table_ref"
    >
      <template slot-scope="{ item, index }">
        <td class="text-sm-center">{{ item.name }}</td>
        <td class="toggle-spacing toggle-adjust">
          <toggle-service
            :is-edit="true"
            model-name="tags"
            :model-id="item.id"
            field="visible"
            v-model="item.is_visible"
            :validate="true"
          />
        </td>
        <td class="text-sm-center">
          <v-icon
            :title="$t('icon.edit')"
            small
            @click="handleEdit(item, index)"
            >mdi-pencil</v-icon
          >
          <v-icon
            :title="$t('icon.delete')"
            small
            @click="handleDelete(item, index)"
            >mdi-delete</v-icon
          >
        </td>
      </template>
      <!-- dialog -->
      <template #wrraping_dialog>
        <v-card-title class="dialog-header">{{ formTitle }}</v-card-title>
        <v-card-text>
          <v-form @submit.prevent="handleSubmit">
            <form-wrapper :validator="$v.form">
              <v-container>
                <v-row>
                  <v-col cols="12" v-if="isEdit">
                    <locale-select @change="onLocaleChange" />
                  </v-col>
                  <v-row>
                    <transition name="fadeIn" mode="out-in">
                      <v-col :cols="12">
                        <form-group name="name">
                          <template slot-scope="{ attrs, listeners }">
                            <v-text-field
                              :loading="loading"
                              v-bind="attrs"
                              v-on="listeners"
                              v-model="form.name"
                              outlined
                            ></v-text-field>
                          </template>
                        </form-group>
                      </v-col>
                    </transition>
                  </v-row>
                  <v-col cols="12">
                    <v-btn
                      :loading="loading"
                      class="primary"
                      type="submit"
                      :disabled="$v.form.$invalid"
                      block
                      >{{ $t("buttons.save") }}</v-btn
                    >
                  </v-col>
                </v-row>
              </v-container>
            </form-wrapper>
          </v-form>
        </v-card-text>
      </template>
      <!-- dialog -->
    </wrapping-table>
  </main>
</template>
<script>
import { minLength, maxLength, required } from "vuelidate/lib/validators";

import { ShowData, UpdateData } from "@/helpers/apiMethods";
import cookie from "js-cookie";
export default {
  name: "Tags",
  data() {
    return {
      isEdit: false,
      loading: false,
      locale: this.locale,
      form: { name: "" },

      headers: ["name", "visible", "actions"],
      tagItem: {},
      tagIndex: ""
    };
  },
  methods: {
    handleSubmit() {
      this.loading = true;
      if (!this.isEdit) {
        // in case create
        const formData = new FormData();
        formData.append("name", this.form.name);
        this.$refs.table_ref
          .handleOnCreate("tags", formData, "tags")
          .finally(() => {
            this.loading = false;
          });
      } else {
        // in case update
        UpdateData({
          reqName: "tags",
          data: { name: this.form.name, locale: this.locale, _method: "put" },
          param: this.tagItem.id
        })
          .then(res => {
            const { tag } = res.data;
            this.$refs.table_ref.handleUpdateItems(tag, this.tagIndex);
            this.$refs.table_ref.toggleDialog();
          })
          .finally(() => (this.loading = false));
      }
    },
    resetData() {
      this.form.name = "";
      this.$v.form.$reset();
    },
    deleteTag(index) {
      this.$delete(this.tags, index);
      if (this.serverErrors) {
        this.$store.dispatch("ClearServerErrors");
      }
    },
    addTag() {
      if (this.tags.includes(this.form.name)) {
        return;
      }
      this.tags.push(this.form.name);
      this.resetData();
    },
    onDialogClose() {
      this.resetData();
      this.isEdit = false;
      this.locale = cookie.get("language");
      this.tags = [];
    },
    handleDelete({ id }, index) {
      this.$refs.table_ref.handleDelete(id, index);
    },
    handleEdit(item, index) {
      this.isEdit = true;
      this.tagItem = item;
      this.tagIndex = index;
      this.$refs.table_ref.toggleDialog();
      this.handleShow();
    },
    handleShow(locale = this.locale) {
      ShowData({ reqName: "tags", param: this.tagItem.id, locale }).then(
        res => {
          const { tag } = res.data;
          this.form.name = tag.name;
        }
      );
    },
    onLocaleChange(locale) {
      this.locale = locale;
      this.handleShow(locale);
    }
  },
  computed: {
    formTitle() {
      if (!this.isEdit) {
        return this.$t("heading.create");
      } else {
        return this.$t("heading.edit");
      }
    },

    serverErrors() {
      return this.$store.getters.serverErrors;
    },
    errorsKeys() {
      return Object.keys(this.serverErrors);
    }
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(20)
      }
    }
  }
};
</script>

<style>
.error-message {
  color: red;
  font-weight: bold;
}
</style>
